export default __webpack_public_path__ + "static/media/reloj.2f6986c5.png";